"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartOutputDto, ShippingInfoInputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CustomerFacingErrorMessages } from "@/constants/CustomerFacingErrorMessages";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";
export const shippingAddressMutationKey = ["shippingAddress"] as const;
export function useShippingAddressMutation() {
  const $ = _c(8);
  const cartClient = useServicesStore(_temp);
  const cartId = useGlobalStore(_temp2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== cartClient || $[1] !== cartId) {
    t0 = async shippingInfo => {
      if (!cartClient) {
        throw new Error("Cart client is not available.");
      }
      if (!cartId) {
        throw new Error("Cart id is not available.");
      }
      return await cartClient.updateShippingInfo(cartId, shippingInfo, CustomerFacingErrorMessages.unableToSaveShippingAddressToCart);
    };
    $[0] = cartClient;
    $[1] = cartId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== queryClient) {
    t1 = cart => {
      queryClient.setQueriesData(CART_ACTIVE_FILTER, cart);
    };
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationKey: shippingAddressMutationKey,
      mutationFn: t0,
      onSuccess: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
}
function _temp2(state_0) {
  return state_0.cartId;
}
function _temp(state) {
  return state.cartClient;
}